import { render, staticRenderFns } from "./Ingreso.vue?vue&type=template&id=13055d75&scoped=true"
import script from "./Ingreso.vue?vue&type=script&lang=js"
export * from "./Ingreso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13055d75",
  null
  
)

export default component.exports